import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/pc/index'
import PcVideo from '@/views/pc/video/video'
import PcBook from '@/views/pc/book/book'
import PcBookList from '@/views/pc/book/booklist'
// import PcBookDetail from '@/views/pc/book/bookdetail'
import PcBookDetail from '@/views/pc/book/detail'
import PcPhoto from '@/views/pc/photo/photo'
import PcIntroduce from '@/views/pc/introduce/index'
import PcResponse from '@/views/pc/response/index'
import PcDownload from '@/views/pc/download/index'
import Page1 from '@/views/pc/page1'
import Appindex from '@/views/m/index'
import AppVideo from '@/views/m/video'
// import AppBook from '@/views/m/book'
// import AppBookDetail from '@/views/m/bookdetail'
import AppBook from '@/views/m/book'
import AppbookList from '@/views/m/booklist'
 import AppBookDetail from '@/views/m/bookdetail'
import AppPhoto from '@/views/m/photo'
import AppIntroduce from '@/views/m/introduce'
import AppAnswer from '@/views/m/answer'
import AppDownload from '@/views/m/download'

Vue.use(Router)

const router= new Router({
  mode:'history',

  routes: [
    {
      path:'/',
      name:'layout',
      redirect:'/pc/index',
      component:()=>import("../../src/views/Layout.vue"),
      children:[
        {
          path: '/pc/index',
          name: 'index',
          component: Index
        },
        {
          path: '/pc/video',
          name: 'pcVideo',
          component: PcVideo
        },
        {
          path: '/pc/book',
          name: 'pcBook',
          component: PcBook,
          redirect:'/pc/book/booklist',
          children: [
            {
              path: 'booklist',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: 'pcBookList',
              component: PcBookList
            },
            {
              path: 'bookdetail/:id',
              name: 'pcbookdetail',
              component: PcBookDetail,
            }
          ]
        },
        // {
        //   path: '/pc/booklist',
        //   name: 'pcBookList',
        //   component: PcBookList
        // },
        // {
        //   path: '/pc/bookdetail',
        //   name: 'pcbookdetail',
        //   component: PcBookDetail
        // },
        // {
        //   path: '/pc/bookdetail',
        //   name: 'pcbookdetail',
        //   component: PcBookDetail
        // },
        {
          path: '/pc/photo',
          name: 'pcPhoto',
          component: PcPhoto
        },
        {
          path: '/pc/introduce',
          name: 'pcIntroduce',
          component: PcIntroduce
        },
        {
          path: '/pc/response',
          name: 'pcRes',
          component: PcResponse
        },
        {
          path: '/pc/download',
          name: 'pcDownload',
          component: PcDownload
        },
        {
          path: '/app/index',
          name: 'appindex',
          component: Appindex
        },
        {
          path: '/app/video',
          name: 'appvideo',
          component: AppVideo
        },
        {
          path: '/app/book',
          name: 'appbook',
          component: AppBook,
          redirect:'/app/book/booklist',
          children: [
            {
              path: 'booklist',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: 'pcBookList',
              component: AppbookList
            },
            {
              path: 'bookdetail/:id',
              name: 'appbookdetail',
              component: AppBookDetail,
            }
          ]
        },
        // {
        //   path: '/app/booklist',
        //   name: 'appbook',
        //   component: AppBook
        // },
        // {
        //   path: '/app/bookdetail',
        //   name: 'appbookdetail',
        //   component: AppBookDetail
        // },
        {
          path: '/app/photo',
          name: 'appimg',
          component: AppPhoto
        },
        {
          path: '/app/introduce',
          name: 'appintroduce',
          component: AppIntroduce
        },
        {
          path: '/app/response',
          name: 'appres',
          component: AppAnswer
        },
        {
          path: '/app/download',
          name: 'appdown',
          component: AppDownload
        }
      ]
    },

    {
      path: '/page1',
      name: 'page1',
      component: Page1
    }
  ]

})
router.beforeEach((to,from,next)=>{
  console.log(to)
  let mobileType=/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  let routePath
  if(to.path.indexOf('app')>=0){
    routePath=to.path.substr(4,to.path.length-1)
  }else{
    routePath=to.path.substr(3,to.path.length-1)
  }
  if(navigator.userAgent.match(mobileType)){
    if(to.path.indexOf('pc')>=0){
      console.log(routePath)
      next({path:'/app'+routePath})
    }
  }else{
    if(to.path.indexOf('app')>=0){
      console.log(routePath)
      next({path:'/pc'+routePath})
    }
  }
  next()

})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js